module.exports = __webpack_public_path__ + "img/2a7f8d2a6c355c448f366da8229f6a0b.png";